export default "__VITE_ASSET__e1AB9jVE__"